import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Lock, UserPlus } from 'lucide-react';

const AccessDenied = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="pt-6 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-10 h-10 text-orange-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Restricted</h1>
            <p className="text-gray-600">
              This area is exclusively for approved QNC Sales Representatives.
            </p>
          </div>

          <div className="bg-blue-50 rounded-lg p-6 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Interested in Joining?</h2>
            <p className="text-sm text-gray-700 mb-4">
              Become a QNC Sales Rep and gain access to:
            </p>
            <ul className="text-sm text-left text-gray-700 space-y-2 mb-4">
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Training materials (PDFs, videos, presentations)</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Product specifications and pricing</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Commission tracking dashboard</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Earn UP TO USD $500 per confirmed generator sale</span>
              </li>
            </ul>
          </div>

          <div className="space-y-3">
            <Link to="/sales-rep" className="block">
              <Button className="w-full bg-blue-600 hover:bg-blue-700">
                <UserPlus className="mr-2 h-5 w-5" />
                Apply to Become a Sales Rep
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full">
                Back to Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;